var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import mixpanel from "mixpanel-browser";
var MIXPANEL_TOKEN = "2c631b9a4583861211985be572676d67";
export var dispatchEvent = function (eventName, properties) {
    mixpanel.init(MIXPANEL_TOKEN);
    var localIdentifier = localStorage.getItem("UserBrowserId");
    mixpanel.track("ArticleComposer_" + eventName, __assign(__assign({}, properties), { session: localIdentifier }));
    console.log("[CCL - Mixpanel] Sending via source app - " + (properties.source || "not defined, using global"));
};
export var trackLinks = function (properties) {
    mixpanel.init(MIXPANEL_TOKEN);
    mixpanel.track_links("a", "ArticleComposer_Link_Clicked", __assign({}, properties));
};
